export default "<button class=\"btn-secondary btn\" (click)=\"closeDialogue()\">Cancel</button> "